import { render, staticRenderFns } from "./CustomerComponent.vue?vue&type=template&id=3f09747a&"
import script from "./CustomerComponent.vue?vue&type=script&lang=js&"
export * from "./CustomerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports